import { danger } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { getAccessParams } from 'utils/shared-access';
import { logError } from 'utils/log';
import { __t, applyTranslations } from 'utils/language';

import type { Action, Dispatch, GetState, ThunkAction } from 'types';

applyTranslations(require('./shared-access-product-list.i18n.json'));

const RESET = 'sharedAccessProductFilters/RESET';
const LOADED = 'sharedAccessProductFilters/LOADED';
const SET_LOADING_STATE = 'sharedAccessProductFilters/SET_LOADING_STATE';

type State = {
  categories: Array<string>,
  brands: Array<string>,
  colors: Array<string>,
  isLoading: boolean
};

const initialState: State = {
  categories: [],
  brands: [],
  colors: [],
  isLoading: false
};

export function resetSharedAccessProductFilters(): Action {
  return {
    type: RESET
  };
}

function dataLoaded(categories: Array<string>, brands: Array<string>, colors: Array<string>): Action {
  return {
    type: LOADED,
    payload: {
      categories,
      brands,
      colors
    }
  };
}

function setLoadingState(loadingState: boolean): Action {
  return {
    type: SET_LOADING_STATE,
    payload: {
      loadingState
    }
  };
}

export function fetchSharedAccessFilters(): ThunkAction {
  return async (dispatch: Dispatch, getState: GetState): Promise<void> => {
    const { config, options } = getAccessParams(getState);
    const url = API.END_POINTS.SHARED_PRODUCT_LIST.sharedProductListFilters();

    dispatch(setLoadingState(true));

    try {
      const { data } = await get(url, config, options);

      dispatch(dataLoaded(data.categories, data.brandNames, data.colors));
    } catch (e) {
      logError(e);
      dispatch(danger(__t('shared_access_product_list_reducer.error_filters')));
    } finally {
      dispatch(setLoadingState(false));
    }
  };
}

export default createReducer<State, any>('sharedAccessProductFilters', initialState, {
  [RESET]: () => initialState,
  [SET_LOADING_STATE]: (state, { loadingState }) => ({
    ...state,
    isLoading: loadingState
  }),
  [LOADED]: (state, { categories, brands, colors }) => ({
    ...state,
    categories,
    brands,
    colors
  })
});
